/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import Calendar from './calendar//ta_IN';
import DatePicker from './date-picker/ta_IN';
import Pagination from './pagination/ta_IN';
import TimePicker from './time-picker/ta_IN';

export default {
  locale: 'ta',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  // locales for all comoponents
  global: {
    placeholder: 'à®¤à¯à®¤à®¿à®¯à¯à®¤à¯ à®¤à¯à®°à¯à®¨à¯à®¤à¯à®à¯à®à¯à®à®µà¯à®®à¯'
  },
  Table: {
    filterTitle: 'à®ªà®à¯à®à®¿à®¯à®²à¯ à®®à¯à®à¯',
    filterConfirm: 'à®à®°à®¿',
    filterReset: 'à®®à¯à®à¯à®à®®à¯',
    emptyText: 'à®¤à®à®µà®²à¯ à®à®²à¯à®²à¯',
    selectAll: 'à®à®©à¯à®¤à¯à®¤à¯à®¯à¯à®®à¯ à®¤à¯à®°à¯à®µà¯à®à¯à®¯à¯',
    selectInvert: 'à®¤à®²à¯à®à¯à®´à®¾à® à®®à®¾à®±à¯à®±à¯',
    sortTitle: 'à®¤à®²à¯à®ªà¯à®ªà¯ à®µà®°à®¿à®à¯à®ªà¯à®ªà®à¯à®¤à¯à®¤à®µà¯à®®à¯'
  },
  Modal: {
    okText: 'à®à®°à®¿',
    cancelText: 'à®°à®¤à¯à®¤à¯ à®à¯à®¯à¯à®¯à®µà¯à®®à¯',
    justOkText: 'à®ªà®°à®µà®¾à®¯à®¿à®²à¯à®²à¯, à®à®°à®¿'
  },
  Popconfirm: {
    okText: 'à®à®°à®¿',
    cancelText: 'à®°à®¤à¯à®¤à¯ à®à¯à®¯à¯à®¯à®µà¯à®®à¯'
  },
  Transfer: {
    titles: ['', ''],
    notFoundContent: 'à®à®³à¯à®³à®à®à¯à®à®®à¯ à®à®¿à®à¯à®à¯à®à®µà®¿à®²à¯à®²à¯',
    searchPlaceholder: 'à®à®à¯à®à¯ à®¤à¯à®à®µà¯à®®à¯',
    itemUnit: 'à®¤à®à®µà®²à¯',
    itemsUnit: 'à®¤à®à®µà®²à¯à®à®³à¯'
  },
  Upload: {
    uploading: 'à®ªà®¤à®¿à®µà¯à®±à¯à®±à¯à®à®¿à®±à®¤à¯...',
    removeFile: 'à®à¯à®ªà¯à®ªà¯ à®à®à®±à¯à®±à¯',
    uploadError: 'à®ªà®¤à®¿à®µà¯à®±à¯à®±à¯à®µà®¤à®¿à®²à¯ à®ªà®¿à®´à¯',
    previewFile: 'à®à¯à®ªà¯à®ªà¯ à®®à¯à®©à¯à®©à¯à®à¯à®à®®à®¿à®à¯à®à¯à®à®³à¯'
  },
  Empty: {
    description: 'à®¤à®à®µà®²à¯ à®à®²à¯à®²à¯'
  },
  Icon: {
    icon: 'à®à®°à¯à®µà®®à¯'
  },
  Text: {
    edit: 'à®¤à®¿à®°à¯à®¤à¯à®¤à¯',
    copy: 'à®¨à®à®²à¯ à®à®à¯',
    copied: 'à®¨à®à®²à¯ à®à®à¯à®à¯à®à®ªà¯à®ªà®à¯à®à®¤à¯',
    expand: 'à®µà®¿à®°à®¿à®µà®¾à®à¯à®à®µà¯à®®à¯'
  },
  PageHeader: {
    back: 'à®ªà®¿à®©à¯ à®à¯à®²à¯à®²à®µà¯à®®à¯'
  }
};
